/* TLF Journal — contents list builder + scrollspy.
   Progressive enhancement only: the article body and its links are plain HTML
   and stay fully usable without this script. The contents lists are generated
   from the body's H2 headings (existing IDs kept; missing IDs are slugified
   from the heading text and made unique). */
(() => {
  const body = document.querySelector('[data-tlfj-body]');
  if (!body) return;
  const headings = [...body.querySelectorAll('h2')];
  if (!headings.length) return;

  const used = new Set();
  document.querySelectorAll('[id]').forEach((el) => used.add(el.id));
  const slugify = (text) =>
    text
      .toLowerCase()
      .replace(/^\s*\d+\s*[.)]\s*/, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';

  const items = headings.map((h) => {
    if (!h.id) {
      let base = slugify(h.textContent);
      let id = base;
      let n = 2;
      while (used.has(id)) {
        id = base + '-' + n;
        n += 1;
      }
      h.id = id;
      used.add(id);
    } else {
      used.add(h.id);
    }
    if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
    const label = h.textContent.trim().replace(/^\s*\d+\s*[.)]\s*/, '');
    return { id: h.id, label };
  });

  const fill = (list) => {
    if (!list) return;
    const frag = document.createDocumentFragment();
    for (const item of items) {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + item.id;
      a.textContent = item.label;
      li.appendChild(a);
      frag.appendChild(li);
    }
    list.appendChild(frag);
  };

  const rail = document.querySelector('[data-tlfj-toc]');
  if (rail) {
    fill(rail.querySelector('ol'));
    rail.hidden = false;
  }
  const inline = document.querySelector('[data-tlfj-toc-inline]');
  if (inline) {
    fill(inline.querySelector('ol'));
    inline.hidden = false;
  }

  const links = [...document.querySelectorAll('[data-tlfj-toc] a')];
  if (links.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (!visible.length) return;
        for (const link of links) {
          if (link.hash === '#' + visible[0].target.id) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        }
      },
      { rootMargin: '-5% 0px -65% 0px', threshold: 0 }
    );
    headings.forEach((h) => observer.observe(h));
  }
})();
